export const checkEntityIds = (id1: string, id2: string): boolean =>
  JSON.parse(id1)?.id === JSON.parse(id2)?.id;
